const baseSettings = {
    // appVersion: 'yyyy.mm.dd.xxxx',
    appVersion: '2026.10.12.1',
}

export default baseSettings;